import { render } from "./ProductFeedbackProductDetails.vue?vue&type=template&id=14cc8dc8"
import script from "./ProductFeedbackProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductFeedbackProductDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__